import React from 'react';

import { Header, PdfList } from 'components';
import { PrivateRoute } from 'utils';

export const PdfHistory = () => {
  PrivateRoute();

  return (
    <>
      <Header />
      <PdfList />
    </>
  );
};
